import { useState, useCallback } from 'react'
import { FiltersKeyType, FiltersLabelMapping, PaginationType } from 'src/types/expert.types'

export type FilteredTag = {
    id?: string | string[]
    key: string
    value: string
    filteredLevelIds?: string[]
    score?: string
    skillIsValidatedBasedOn?: string
    type?: string
}

export type UseTagProps = {
    setPagination: (value: PaginationType | ((prev: PaginationType) => PaginationType)) => void
}

const useTag = ({ setPagination }: UseTagProps) => {
    const [tagsList, setTagsList] = useState<FilteredTag[]>([])
    const [removedTagName, setRemovedTagName] = useState<string>('')

    const setPaginationToFirstPage = useCallback(() => {
        setPagination(prev => ({ ...prev, page: 1 }))
    }, [setPagination])

    const updateTags = useCallback(
        (newTagOrTags: FilteredTag | FilteredTag[]) => {
            setRemovedTagName('')

            const newTagsArray = Array.isArray(newTagOrTags) ? newTagOrTags : [newTagOrTags]

            setTagsList(prevTagList => {
                const updatedTags = [...prevTagList]
                newTagsArray.forEach(newTag => {
                    if (newTag && newTag.key) {
                        const existingTagIndex = updatedTags.findIndex(
                            tag =>
                                tag.key === newTag.key &&
                                (tag.key === FiltersLabelMapping.expertiseArea
                                    ? tag.value.toLowerCase() === newTag.value.toLowerCase()
                                    : true)
                        )
                        if (existingTagIndex !== -1) {
                            updatedTags[existingTagIndex] = newTag
                        } else {
                            updatedTags.push(newTag)
                        }
                    }
                })
                return updatedTags
            })

            setPaginationToFirstPage()
        },
        [setPaginationToFirstPage]
    )

    const removeTags = useCallback(
        (key: string, value: string) => {
            setTagsList(prevTagList =>
                prevTagList.filter(tag => {
                    if (tag.key === FiltersLabelMapping.expertiseArea) {
                        return `${tag.key}-${tag.value}` !== `${key}-${value}`
                    }
                    return tag.key !== key
                })
            )
            setPaginationToFirstPage()
            setRemovedTagName(key)
        },
        [setPaginationToFirstPage]
    )

    const removeAllTags = useCallback(() => {
        setRemovedTagName(FiltersKeyType.SelectAll)
        setTagsList([])
        setPaginationToFirstPage()
    }, [setPaginationToFirstPage])

    return { tagsList, removedTagName, removeTags, updateTags, removeAllTags }
}

export default useTag
